import React, { useEffect, useRef } from "react"

const MentionDropdown = ({ assistants, isVisible, position, onSelect, onClose, searchTerm, selectedAssistant }) => {
  const dropdownRef = useRef(null)

  // Filter assistants based on search term
  let filteredAssistants = assistants.filter((assistant) => {
    return parseInt(assistant.id) !== parseInt(selectedAssistant?.id)
  });

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose()
      }
    }

    if (isVisible) {
      document.addEventListener("mousedown", handleClickOutside)
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [isVisible, onClose])

  if (!isVisible) return null

  return (
    <div
      ref={dropdownRef}
      className="mention-dropdown"
      style={{
        position: "absolute",
        bottom: `100%`,
        left: "0",
        zIndex: 1000,
      }}
    >
      {filteredAssistants.length > 0 ? (
        <ul>
          {filteredAssistants.map((assistant) => (
            <li key={assistant.id} onClick={() => onSelect(assistant)} className="mention-item">
              <span className="mention-name">@{assistant.name.replace(/\s+/g, "")}</span>
              {assistant.type && <span className="mention-type">{assistant.type}</span>}
            </li>
          ))}
        </ul>
      ) : (
        <div className="no-results">No assistants found</div>
      )}
    </div>
  )
}

export default MentionDropdown
